/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ResultsRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let surveyId = params.survey_id;
    return hash({
      survey: this.store.findRecord('surveys/survey', surveyId),
      responses: this.store.query('surveys/response', { surveyId }),
      communityNotices: this.store.query('posts/communitynotice', { surveyId }),
      studentNotices: this.store.query('posts/studentnotice', { surveyId }),
      students: this.store.query('person', { type: PersonType.LEARNER }),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
